import { ATLAS_ASSET_TOKEN_LOCAL_STORAGE_KEY } from "@/modules/atlas-asset-token/constants";
import localforage from "localforage";

export const clearAtlasAssetToken = async (): Promise<void> => {
  await localforage.removeItem(ATLAS_ASSET_TOKEN_LOCAL_STORAGE_KEY);
};
